import { Component, OnInit } from '@angular/core';
import { IBasicOrganisationInfo } from '../../../interfaces/telephony/basic-organisation-info';
import { OrganisationsService } from '../../../services';
import { EventService } from '../../../services';
import { OrganisationSelectorEventTypeEnum } from '../../../interfaces/telephony/organisation-selector-event-type.enum';
import { IOrganisationSelectorEvent } from '../../../interfaces/telephony/organisation-selector-event';
import { OrganisationTypeEnum } from '../../../enums/organisation-types';
import { SelectItem } from 'primeng';

@Component({
  selector: 'organisation-selector',
  templateUrl: './organisation-selector.component.html',
  styleUrls: ['./organisation-selector.component.scss'],
})
export class OrganisationSelectorComponent {
  allOrganisationInfos: IBasicOrganisationInfo[];
  organisationInfos: IBasicOrganisationInfo[];
  searchText: string = '';
  orgSelectorVisible = false;
  hoverMore: number;
  loading = false;

  emitSelectEvent = false;
  forDeployment = false;

  organisationStatusOptions: {}[] = [
    { value: 'all', label: 'View All' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Deactivated' },
    { value: 'suspended', label: 'Suspended' },
  ];

  organisationTypeOptions: SelectItem[] = [
    { value: 0, label: 'Show All' },
    { value: 2, label: 'Customers' },
    { value: 3, label: 'Suppliers' },
  ];

  orgType = 0;

  orgStatusName = { false: 'active', true: 'deactivated' };
  showActive? = false;
  orgStatus = 'active';

  constructor(private orgService: OrganisationsService, private eventService: EventService) {
    this.eventService.OrganisationSelectorEvent.subscribe((event: IOrganisationSelectorEvent) => {
      if (event.eventType == OrganisationSelectorEventTypeEnum.OpenSelector) {
        this.orgSelectorVisible = true;
        this.emitSelectEvent = event.args;
        this.forDeployment = event.forDeployment;

        const chosenOrgType = event.orgType || 0;

        if (this.organisationTypeOptions.map((x) => x.value).includes(chosenOrgType)) {
          this.orgType = chosenOrgType;
        }

        // load all organisation information once on start
        if (this.allOrganisationInfos == null || this.allOrganisationInfos.length == 0) {
          this.loadOrganisationInfo();
        } else {
          this.filterResults();
        }
        // focus on input
        setTimeout(() => {
          let element = document.getElementById('orgNameInput');
          if (element) {
            element.focus();
          }
        }, 150);
      }
    });
  }

  loadOrganisationInfo() {
    this.loading = true;
    // load all organisation information once on start
    this.orgService.getCurrentUserOrgTypeId().then((id) => {
      if (id != OrganisationTypeEnum.Engineius) {
        return;
      }
      this.orgService
        .getBasicInfos()
        .then((results) => {
          this.allOrganisationInfos = results;
          this.filterResults();
        })
        .finally(() => {
          this.loading = false;
        });
    });
  }

  searchTextChanged(text) {
    text = text || '';

    let search = text.toLowerCase().trim();
    this.searchText = search;

    this.filterResults();
  }

  filterResults() {
    const orgType = this.orgType;

    // helpers for conditions
    const matchesOrgType = (x) => orgType === 0 || x.organisationTypeId === orgType;

    const matchesStatus = (x) => {
      if (this.orgStatus === 'all') {
        return true;
      } else if (this.orgStatus === 'inactive') {
        return x.inactive && !x.suspended;
      } else if (this.orgStatus === 'suspended') {
        return x.suspended;
      } else if (this.orgStatus === 'active') {
        return !x.inactive && !x.suspended;
      }
      return false;
    };

    const matchesSearchText = (x) => {
      const searchText = this.searchText.toLowerCase();
      return (
        (x.name && x.name.toLowerCase().includes(searchText)) ||
        (x.emailAddress && x.emailAddress.toLowerCase().includes(searchText)) ||
        (x.phoneNumber && x.phoneNumber.includes(searchText)) ||
        (x.organisationPhoneNumbers &&
          x.organisationPhoneNumbers.some(
            (y) => y.phoneNumber && y.phoneNumber.includes(searchText),
          ))
      );
    };

    // filter on conditions
    this.organisationInfos = this.allOrganisationInfos?.filter(
      (x) => matchesOrgType(x) && matchesStatus(x) && matchesSearchText(x),
    );
  }

  organisationSelected(org: IBasicOrganisationInfo) {
    if (this.emitSelectEvent) {
      this.eventService.OrganisationSelectorEvent.emit({
        eventType: this.forDeployment
          ? OrganisationSelectorEventTypeEnum.DeploySupplierSelected
          : OrganisationSelectorEventTypeEnum.OrganisationSelected,
        args: org,
      });
    } else {
      this.eventService.OrganisationSelectorEvent.emit({
        eventType: OrganisationSelectorEventTypeEnum.AssociateOrganisationSelected,
        args: org,
      });
    }

    this.orgSelectorVisible = false;
  }

  orgSelectorVisibilityChanged(visible) {
    if (!visible) {
      this.eventService.OrganisationSelectorEvent.emit({
        eventType: OrganisationSelectorEventTypeEnum.SelectorClosed,
      });
      this.organisationInfos = [];
      this.searchText = '';
      this.orgType = 0;
      this.orgStatus = 'active';
      this.orgSelectorVisible = false;
    }
  }

  organisationStatusChange(orgStatus) {
    this.orgStatus = orgStatus;
    this.filterResults();
  }

  organisationTypeChange(orgType) {
    this.orgType = orgType;
    this.filterResults();
  }
}
